export default {"src":"/_next/static/media/content-icon.e4f80d34.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};